<app-page-header title="Settings" [breadcrumbs]="breadcrumbs" [buttons]="buttons"></app-page-header>

<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <mat-tab-group mat-align-tabs="start" (selectedIndexChange)="changeTab($event)" [selectedIndex]="selectedTab">
                <!-- <mat-tab>
                    <ng-template mat-tab-label>
                        Profile
                    </ng-template>
                    <div>Content 1</div>
                </mat-tab> -->
                <mat-tab *appCan="'edit_tenant_settings'">
                    <ng-template mat-tab-label>
                        Organisation
                    </ng-template>
                    <app-organisation-settings></app-organisation-settings>
                </mat-tab>
                <mat-tab *appCan="'view_roles'">
                    <ng-template mat-tab-label>
                        Roles
                    </ng-template>
                    <app-roles *ngIf="!activeRole; else editRole"></app-roles>
                    <ng-template #editRole>
                        <app-role-edit [roleData]="activeRole"></app-role-edit>
                    </ng-template>
                </mat-tab>
                <mat-tab *appCan="'view_settings'">
                    <ng-template mat-tab-label>
                        System Settings
                    </ng-template>
                    <app-system-settings></app-system-settings>
                </mat-tab>

                <mat-tab *appCan="'view_credit_logs'">
                    <ng-template mat-tab-label>
                        Credit Logs
                    </ng-template>
                   <app-credit-logs></app-credit-logs>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
